import { fetchApiDataV2 } from "../../utils/utils"

export const getTrailer = async (appInfo,teaser_vanity_url)=>{
  const api=`trailer/${teaser_vanity_url}`
  return await fetchApiDataV2(appInfo,api)
}

